import { Component, OnInit } from '@angular/core';
import { SELECTED_VENDOR } from '@app/_helpers';

@Component({
  selector: 'app-footer',
  templateUrl: './vendor-templates/lynk.footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  socialLinks = SELECTED_VENDOR.socialLinks;
  legalLinks = SELECTED_VENDOR.legalLinks;

  constructor() { }

  ngOnInit() {
  }

  comingSoon(a, b) {}

}
